module.exports = __webpack_public_path__ + "img/resized-APP-0023-2.148ae888.png";